















































































































































































import { Vue } from 'vue-property-decorator'
import { CIcon } from '@coreui/icons-vue'
import {
  cilCalendarPlus,
  cilFilePdf,
  cilDataTransferDown,
} from '@coreui/icons-pro'
import ScreenTile from '../components/ScreenTile.vue'
import AddEventModal from '../components/calendar/AddEventModal.vue'
import { mapState } from 'vuex'
import '../styles/calendar.css'
import * as _ from 'lodash'

interface IEvent {
  name: string
  start: Date
  end: Date
  color: string
  timed: boolean
  details: string
}

export default Vue.extend({
  components: { ScreenTile, CIcon, AddEventModal },
  data: function () {
    return {
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
      } as {
        [key: string]: string
      },
      selectedEvent: null as any,
      selectedElement: null as any,
      selectedOpen: false,
      events: [] as IEvent[],
      showModal: false,
      addEditType: 'edit',
      calendarAddIcon: cilCalendarPlus,
      downloadIcon: cilDataTransferDown,
      pdfIcon: cilFilePdf,
      colors: [
        { name: 'Extension payments', color: '#2F353A' },
        { name: 'Tax estimates', color: '#005EB8' },
        { name: 'Annual BRT/Renewal', color: '#5867CF' },
        {
          name: 'Deadline Reinsurance Distribution Request',
          color: '#5A7631',
        },
        { name: 'Remittance Close', color: '#95B466' },
        { name: 'Holiday', color: '#FED201' },
        { name: 'Special Event', color: '#f44336' },
        { name: 'Filing Deadline', color: '#00bcd4' },
      ],
      loading: false,
    }
  },
  async mounted() {
    if (this.$refs.calendar) {
      ;(this.$refs.calendar as any).updateTimes()
      this.focus = ''
      this.loading = true
      await this.getEvents()
      this.loading = false
    }
  },
  computed: {
    ...mapState(['user']),
    eventsAfterToday: function () {
      if (!this || !this.events) return []
      return this.events
        .filter(
          (event) => new Date(event.start).getTime() > new Date().getTime()
        )
        .sort((a, b) => (a.start < b.start ? -1 : 1))
    },
    eventGroupsAfterToday: function () {
      return _.groupBy(
        this.eventsAfterToday,
        (e) =>
          `${new Date(e.start).getFullYear()}-${new Date(e.start).getMonth()}`
      )
    },
  },
  methods: {
    getEvents: async function () {
      const serverEvents = await (await fetch('/api/Calendar')).json()
      this.events = serverEvents.map((x: any) => ({
        name: x.name,
        start: x.date.split('T')[0],
        end: x.endDate ? x.endDate.split('T')[0] : x.date.split('T')[0],
        color: x.color,
        timed: false,
        id: x.id,
        details: x.description,
        categoryId: x.categoryId,
        typeId: x.typeId,
      }))
      const today = new Date()
      const today_year = `0000${today.getFullYear().toString()}`.slice(-4)
      const today_month = `00${(today.getMonth() + 1).toString()}`.slice(-2)
      const today_day = `00${today.getDate().toString()}`.slice(-2)
      const todayFormatted = `${today_year}-${today_month}-${today_day}`
      this.events.push({
        name: 'Today',
        start: todayFormatted,
        end: todayFormatted,
        color: 'blue',
        timed: false,
        details: "It's today! Make it the best day you can make it",
      })
    },
    deleteEvent: async function (id: number) {
      await (await fetch(`/api/Calendar/${id}`, { method: 'delete' })).json()
      this.selectedOpen = false
      this.getEvents()
    },
    showAdd: async function () {
      this.addEditType = 'add'
      this.showModal = true
    },
    showEdit: async function () {
      this.selectedOpen = false
      this.addEditType = 'edit'
      this.showModal = true
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      if (this.$refs.calendar) (this.$refs.calendar as any).prev()
    },
    next() {
      if (this.$refs.calendar) (this.$refs.calendar as any).next()
    },
    viewDay({ date }: { date: string }) {
      this.focus = date
      this.type = 'day'
    },
    exportToPDF: function () {
      window.open('/api/Calendar/Export')
    },
    exportToICS: function (event) {
      ;(this as any).$ics.removeAllEvents()
      const localStart = new Date(event.start)
      localStart.setMinutes(
        localStart.getMinutes() + localStart.getTimezoneOffset()
      )
      const localEnd = new Date(event.end)
      localEnd.setMinutes(localEnd.getMinutes() + localEnd.getTimezoneOffset())
      ;(this as any).$ics.addEvent(
        'en-us',
        event.name,
        event.details,
        '',
        localStart,
        localEnd
      )
      ;(this as any).$ics.download(event.name)
    },
    monthName: function (date) {
      return date.toLocaleString('en-US', { month: 'long' })
    },
    showEvent: async function ({
      nativeEvent,
      event,
    }: {
      nativeEvent: Event
      event: any
    }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.selectedOpen = true
          })
        )
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
  },
})
